import { twMerge } from "tailwind-merge";

export default function CollectionSectionLabel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        "flex-1 text-[18px] font-light md:text-[20px] pb-[10px] border border-solid border-x-0 border-t-0 border-b border-b-inactive-gray",
        className
      )}
    >
      {children}
    </div>
  );
}
